export const MY_DOCUMENTS = {
  SERVICE: 0,
  INVOICE: 1,
  WELCOME: 2,
  PREPAY: 3,
};
